import {FormGroup, FormControl, Validators} from '@angular/forms';
import {AlertController, NavController, ModalController} from 'ionic-angular';
import {Component} from '@angular/core';
import {InAppBrowser, InAppBrowserObject} from '@ionic-native/in-app-browser';
import {BackendModule} from '../../../../../modules/backend.module';
import {MembershipService} from '../membership.service';
import {SessionService} from '../../../../../services/session';
import {LocationsService} from '../../../../../services/locations';
import {TabsService} from '../../../tabs.service';
import {AuthService} from '../../../../../services/auth';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'page-new-membership',
  templateUrl: 'new-membership.html'
})
export class NewMembershipPage {
  coupon = '';
  unprocessedCoupon = false; //this is to make sure user validated coupon
  couponValid = false;
  membershipForm = new FormGroup({});
  now = new Date();
  currentYear = this.now.getFullYear();
  showPaymentsIframe = false;

  acceptCLTerms = false;

  browser: any;
  intervalID: number;
  isBuying = false;

  constructor(
    public alertCtrl: AlertController,
    public sessionService: SessionService,
    public backendModule: BackendModule,
    public membershipService: MembershipService,
    public locationsService: LocationsService,
    public navCtrl: NavController,
    public tabsService: TabsService,
    public iab: InAppBrowser,
    public modalCtrl: ModalController,
    public authService: AuthService
  ) {
  }

  ngOnInit() {
    this.membershipForm = new FormGroup({
      acceptTerms: new FormControl(false, [Validators.requiredTrue]),
    });
    // this.getStatesAndCities();
    // if (this.sessionService.user.subscription) {
    //   this.initializeForm(
    //     this.sessionService.user.subscription.owner_name,
    //     this.sessionService.user.subscription.address,
    //     this.sessionService.user.subscription.cp,
    //     this.sessionService.user.subscription.phone
    //   );
    // } else {
    //   this.initializeForm(null, null, null, null);
    // }
  }

  ngOnDestroy() {
    // this.locationsService.removeStatesAndCities();
  }

  // getStatesAndCities() {
  //   this.backendModule.getAPI('locations').subscribe(
  //     (result: any) => {
  //       this.locationsService.states = result.states;
  //       this.locationsService.cities = result.cities;
  //     },
  //     err => {
  //       this.sessionService.reportError(
  //         'newMembershipPage',
  //         'getStatesAndCities()',
  //         err
  //       );
  //     }
  //   );
  // }

  // initializeForm(name, address, zip, phone) {
  //   if (this.locationsService.country === 'MX' &&
  //     this.membershipService.processor === 'conekta') {
  //     this.membershipForm = new FormGroup({
  //       acceptTerms: new FormControl(false, [Validators.requiredTrue]),
  //       number: new FormControl(null, [
  //         Validators.required,
  //         this.validCardNumber.bind(this)
  //       ]),
  //       name: new FormControl(name, Validators.required),
  //       exp: new FormControl(null, [Validators.required]),
  //       cvc: new FormControl(null, [
  //         Validators.required,
  //         this.validCVC.bind(this)
  //       ]),
  //       address: new FormGroup({
  //         street1: new FormControl(address, [Validators.required]),
  //         street2: new FormControl(null),
  //         city: new FormControl(null, [Validators.required]),
  //         state: new FormControl(null, [Validators.required]),
  //         zip: new FormControl(zip, [Validators.required]),
  //         phone: new FormControl(phone, [Validators.required])
  //       })
  //     });
  //   } else {
  //     this.membershipForm = new FormGroup({
  //       acceptTerms: new FormControl(false, [Validators.requiredTrue]),
  //     });
  //   }
  // }

  // validCardNumber(
  //   control: FormControl
  // ): { [cardNumberIsValid: string]: boolean } {
  //   /*
  //   if (this.conektaService.validateNumber(control.value)) {
  //     return null;
  //   }
  //   */
  //   return {cardNumberIsInvalid: true};
  // }

  // validCVC(control: FormControl): { [CVCIsValid: string]: boolean } {
  //   /*
  //   if (this.conektaService.validateCVC(control.value)) {
  //     return null;
  //   }
  //   */
  //   return {CVCIsInvalid: true};
  // }

  validateCoupon() {
    this.unprocessedCoupon = false;
    this.backendModule
      .postAPI(`coupons/validate`, {
        coupon_name: this.coupon,
        user_id: this.sessionService.user.id,
        plan: this.membershipService.planName
      })
      .subscribe(
        (result: any) => {
          if (!result.valid) {
            this.couponValid = false;
            this.membershipService.finalPrice = this.membershipService.membershipPrice;
            let alert = this.alertCtrl.create({
              title: 'Cupón ' + this.locationsService.translate('invalid'),
              buttons: [
                {
                  text: 'OK',
                  handler: () => {
                    this.coupon = '';
                  }
                }
              ]
            });
            alert.present();
          }
          if (result.valid) {
            this.couponValid = true;
            this.membershipService.finalPrice =
              this.membershipService.membershipPrice -
              this.membershipService.membershipPrice *
              (result.coupon.discount / 100);
            this.membershipService.couponName = result.coupon.name;
          }
        },
        err => {
          this.sessionService.reportError(
            'newMembershipPage',
            'validateCoupon()',
            err
          );
        }
      );
  }

  confirmSubscription() {
    // MX and chile
    if (!this.couponValid && this.coupon !== '') {
      this.unprocessedCoupon = true;
      let alert = this.alertCtrl.create({
        title: 'Tienes un cupón sin validar',
        cssClass: 'red-text-alert',
        buttons: [
          {
            text: 'Regresar',
            role: 'cancel'
          },
          {
            text: 'Validar',
            handler: () => {
              this.validateCoupon();
            }
          }
        ]
      });
      alert.present();
      return;
    }
    // const paymentProcessor = this.locationsService.country === 'MX' ?
    //   this.membershipService.processor :
    //   this.locationsService.translate('paymentProcessor');
    // `processor=${paymentProcessor}` +

    this.isBuying = true;

    // this.socket = this.backendModule.openSocket()
    const urlToLoad: string = encodeURI(`${this.membershipService.paymentsUrl}?` +
      `processor=${this.locationsService.translate('paymentProcessor')}` +
      `&user_id=${this.sessionService.user.id}` +
      `&amount=${this.membershipService.finalPrice}` +
      `&time=${new Date().getTime()}` +
      `&coupon=${this.membershipService.couponName}` +
      `&plan=${this.membershipService.planName}` +
      `&country=${this.locationsService.versionService.country}`)

    const windowProxy = this.openBrowser(urlToLoad);
    this.verifyPurchase(windowProxy);

  }


  async getLastIncome(): Promise<any> {
    const params = new HttpParams()
      .append('pagination[page]', '1')
      .append('pagination[count]', '1');

    return this.backendModule.getAPI('incomes', {
      observe: 'response',
      params: params
    }).toPromise().then((response: any) => {
      if (response.body.data && response.body.data.length) {
        return response.body.data[0];
      }
    });
  }

  openBrowser(url) {
    return window.open(url, '_blank', 'location=yes');
  }

  verifyPurchase(windowProxy: Window) {
    const currentDate = new Date();

    this.intervalID = window.setInterval(() => {
      this.getLastIncome()
        .then((lastIncome: any) => {
          if (lastIncome == null) {
            return;
          }

          const lastIncomeCreatedAt = new Date(lastIncome.created_at);

          console.debug(
            'Comparing incomes',
            'Current Date', currentDate.valueOf(),
            'last Income Date', lastIncomeCreatedAt.valueOf()
          );


          if (lastIncomeCreatedAt.valueOf() > currentDate.valueOf()) {
            console.log('Purchase detected', lastIncomeCreatedAt);
            window.clearInterval(this.intervalID);
            this.completePurchase();

            windowProxy.close();
          }
        })
        .catch(error => {
          console.error('Could n\'t get the last income');
          console.error(error);
        })
    }, 2000);
  }

  async completePurchase() {
    this.isBuying = false;
    window.clearInterval(this.intervalID);

    await this.authService.getUserInfo(this.sessionService.user.id);
    await this.navCtrl.popToRoot();
    this.navCtrl.parent.select(this.tabsService.PROFILE);
  }

  retryPurchase() {
    this.isBuying = false;
    window.clearInterval(this.intervalID);
  }

  ionViewWillLeave() {
    window.clearInterval(this.intervalID);
  }
}




// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/new-membership/new-membership.ts